// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__VOsGG","header__wrapper":"style_header__wrapper__JwgLN","header-logo":"style_header-logo__VhOd4","header__code":"style_header__code__PZiHd"};